/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAddDesign: currentUser && currentUser.Role === 3,
    canAddSite: currentUser && currentUser.Role === 3,
  };
}
